import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { b as bem } from './bem.js';
import { r as resolveAppearance } from './transformTagName.js';

const getRandomInt = () => {
    return Math.floor(Math.random() * 1000);
};

const cosmosSpinnerCss = ":host{display:block;height:1em;width:1em}.cosmos-spinner{color:var(--cosmos-spinner-color, #000F1E);display:block;height:100%;width:100%}@media screen and (prefers-reduced-motion: no-preference){.cosmos-spinner{-webkit-animation:spin 0.7s linear infinite;animation:spin 0.7s linear infinite}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}}.cosmos-spinner *{stop-color:currentColor}.cosmos-spinner--appearance-light{color:var(--cosmos-spinner-color, #FFFFFF)}";
const CosmosSpinnerStyle0 = cosmosSpinnerCss;

const generateClassNames = bem('cosmos-spinner');
const CosmosSpinner = /*@__PURE__*/ proxyCustomElement(class CosmosSpinner extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.appearance = undefined;
        this.computedAppearance = 'dark';
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    componentWillLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    render() {
        /*
        Edge 18 ignores shadow DOM boundaries when using ids and therefore
        applies the same color as the first definition to all other instances.
        As a fix, we suffix a random number to the gradient id,
        making it unique in the document DOM tree.
        */
        const uniqueId = getRandomInt();
        return (h("svg", { class: generateClassNames({
                appearance: this.computedAppearance,
            }), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { d: "M16.6292 7.75012C17.1997 8.73827 17.5 9.85919 17.5 11.0002C17.5 12.1412 17.1997 13.2621 16.6292 14.2503", stroke: `url(#segment-1-${uniqueId})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h("path", { d: "M16.6291 14.2502C16.0586 15.2384 15.2381 16.0589 14.25 16.6294C13.2619 17.1999 12.141 17.5003 11 17.5003", stroke: `url(#segment-2-${uniqueId})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h("path", { d: "M11 17.5003C9.859 17.5003 8.73812 17.1999 7.75 16.6294C6.76188 16.0589 5.94134 15.2384 5.37085 14.2502", stroke: `url(#segment-3-${uniqueId})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h("path", { d: "M5.37086 14.2503C4.80035 13.2621 4.5 12.1412 4.5 11.0002C4.5 9.85919 4.80035 8.73827 5.37086 7.75012", stroke: `url(#segment-4-${uniqueId})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h("path", { d: "M5.37085 7.75008C5.94134 6.76196 6.76188 5.94141 7.75 5.3709C8.73812 4.80039 9.859 4.50003 11 4.5", stroke: `url(#segment-5-${uniqueId})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h("defs", null, h("linearGradient", { id: `segment-1-${uniqueId}`, x1: "15.5", y1: "8.5", x2: "15.5", y2: "13.5", gradientUnits: "userSpaceOnUse" }, h("stop", { "stop-opacity": "0" }), h("stop", { offset: "1", "stop-opacity": "0.25" })), h("linearGradient", { id: `segment-2-${uniqueId}`, x1: "15.5", y1: "13.5", x2: "13.2074", y2: "17.3236", gradientUnits: "userSpaceOnUse" }, h("stop", { "stop-opacity": "0.25" }), h("stop", { offset: "1", "stop-opacity": "0.5" })), h("linearGradient", { id: `segment-3-${uniqueId}`, x1: "11", y1: "16", x2: "9.0824", y2: "12.3929", gradientUnits: "userSpaceOnUse" }, h("stop", { "stop-opacity": "0.5" }), h("stop", { offset: "1", "stop-opacity": "0.75" })), h("linearGradient", { id: `segment-4-${uniqueId}`, x1: "6.5", y1: "13.5", x2: "6.5", y2: "8.5", gradientUnits: "userSpaceOnUse" }, h("stop", { "stop-opacity": "0.75" }), h("stop", { offset: "1" })), h("linearGradient", { id: `segment-5-${uniqueId}`, x1: "7", y1: "8", x2: "9.13409", y2: "4.76796", gradientUnits: "userSpaceOnUse" }, h("stop", null), h("stop", { offset: "1" })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return CosmosSpinnerStyle0; }
}, [1, "cosmos-spinner", {
        "appearance": [513],
        "computedAppearance": [32]
    }, undefined, {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-spinner"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-spinner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSpinner);
            }
            break;
    } });
}

export { CosmosSpinner as C, defineCustomElement as d };
